function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18efa4;}.b{fill:#18ea95;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(45.627)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 45.007)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(11.407 34.22)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(22.814 22.814)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(34.22 11.407)"
}, React.createElement("rect", {
  className: "a",
  width: 1.826,
  height: 1.826
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(12.156 35.133)"
}, React.createElement("rect", {
  className: "b",
  width: 0.328,
  height: 11.407
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(23.562 23.726)"
}, React.createElement("rect", {
  className: "b",
  width: 0.328,
  height: 22.814
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(34.969 12.32)"
}, React.createElement("rect", {
  className: "b",
  width: 0.328,
  height: 34.22
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(46.376 0.913)"
}, React.createElement("rect", {
  className: "b",
  width: 0.328,
  height: 45.627
}));

var SvgSalesManagement = function SvgSalesManagement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 47.453,
    height: 46.833,
    viewBox: "0 0 47.453 46.833",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSalesManagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sales_Management.1c0781eb.svg";
export { ForwardRef as ReactComponent };